/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */
import { IStyleFunctionOrObject } from "office-ui-fabric-react";
import {
  IErrorStateComponentStyleProps,
  IErrorStateComponentStyles,
} from "@cseo/controls";
// eslint-disable-next-line @typescript-eslint/ban-types
export const ErrorHeaderStyle: IStyleFunctionOrObject<
  IErrorStateComponentStyleProps,
  IErrorStateComponentStyles
> = {
  root: {
    paddingTop: 5,
    paddingBottom: 10,
  },
  errorStateHeading: {
    fontSize: 18,
    "@media screen and (min-width: 320px) and (max-width: 800px)": {
      fontSize: 15,
      paddingTop: 23,
    },
    "@media screen and (min-width: 801px) and (max-width: 1023px)": {
      fontSize: 16,
      paddingTop: 23,
    },
    "@media screen and (min-width: 1366px) and (max-width: 1919px)": {
      fontSize: 18,
    },
    "@media screen and (min-width: 1024px) and (max-width: 1365px)": {
      fontSize: 16,
      paddingTop: 23,
    },
  },
  errorStateDescription: {
    "@media screen and (min-width: 320px) and (max-width: 539px)": {
      fontSize: 12,
      paddingTop: 8,
    },
    "@media screen and (min-width: 540px) and (max-width: 800px)": {
      fontSize: 11,
      paddingTop: 12,
    },
    "@media screen and (min-width: 801px) and (max-width: 1023px)": {
      fontSize: 12,
      paddingTop: 12,
    },
    "@media screen and (min-width: 1024px) and (max-width: 1500px)": {
      paddingLeft: 40,
      paddingTop: 12,
      fontSize: 12,
    },
  },
  errorStateCtaButtonStyle: {
    borderColor: "#b1b1b1 !important",
    backgroundColor: "#ffffff",
    color: "#171717 !important",
    selectors: {
      ":hover": {
        backgroundColor: "#F2F2F2",
      },
      ":active": {
        backgroundColor: "#F2F2F2",
      },
    },
  },
};
